import { useSearchParams } from "react-router-dom";
import { portfolioAnalysisPages } from "@app/const/route.const";
import { ModuleScenarioAnalysisReport } from "./ModuleScenarioAnalysisReport";

export const PdfPortfolioAnalysisScenarioAnalysisReportPage = () => {
  const [searchParams] = useSearchParams();
  const { portfolioGroupId, moduleId, dataIds } =
    portfolioAnalysisPages.getPdfScenarioAnalysisReportParams(searchParams);

  return (
    <ModuleScenarioAnalysisReport
      portfolioGroupId={portfolioGroupId}
      moduleId={moduleId}
      dataIds={dataIds}
      footer="Portfolio Analysis"
    />
  );
};
